
import { Button, ButtonManageRef, FormControl, FormGroup, Scheme, TextAreaInput, TextInput } from "@rivtn/noseur";
import { ConfirmDialog } from "./ConfirmDialog";
import { Schemes, Utils } from "../../utils";
import { i18nManager } from "../../i18n";

export interface ArticleDialogLabel {
    title: string;
    update: string;
    delete: string;
    publish: string;
    updateTitle: string;
    delete_desc: string;
    delete_title: string;
    titlePlaceholder: string;
    contentPlaceholder: string;
}

export interface ArticleDialogArticle {
    title: string;
    content: string;
}

export interface ArticleDialogProps<T extends ArticleDialogArticle> {
    article?: T;
    labels: ArticleDialogLabel;
    onDelete: (article: T) => void;
    preComponents?: React.ReactElement;
    secondaryComponents?: React.ReactElement;
    onAction: (article: T, button?: ButtonManageRef, dialogErrorRef?: any) => void;
}

export function ArticleDialog<T extends ArticleDialogArticle>(props: ArticleDialogProps<T>) {
    const iframeRef = { current: null } as any;
    const dialogErrorRef = { current: null } as any;
    const { labels, article = {} as any, preComponents, secondaryComponents } = props;

    const dialog = ConfirmDialog({
        closable: true,
        noControl: true,
        maximized: true,
        style: { maxWidth: "100%", margin: 0 },
        content: (<div className="article-dialog">
            <FormGroup className="form finputs">
                <p className="t">{article?.title ? labels.updateTitle : labels.title}</p>
                {preComponents}
                <FormControl fill scheme={Schemes.RIVTN_QUIRINUS} borderless>
                    <TextInput borderless placeholder={labels.titlePlaceholder} defaultValue={article?.title} onInputComplete={(v) => {
                        article.title = v;
                    }} />
                </FormControl>
                <FormControl borderless isFieldset fill scheme={Schemes.RIVTN_QUIRINUS} style={{ flex: 1, height: "100%" }} className="move-to-noseru-for-fieldset-content-customization" >
                    <TextAreaInput borderless fill style={{ height: "100%" }} placeholder={labels.contentPlaceholder} defaultValue={article?.content} onInput={({ target: { value } }: any) => {
                        article.content = value;
                        if (!iframeRef.current) return;
                        iframeRef.current.src = 'data:text/html;charset=utf-8,' + encodeURIComponent(Utils.MARKDOWN_CONVERTER.makeHtml(value));
                    }} />
                </FormControl>
                <div ref={dialogErrorRef} className="error" style={{ marginBottom: 10 }}> </div>
                <div className="controls">
                    <div>
                        <Button textOnly scheme={Schemes.RIVTN_QUIRINUS} text={<span style={{ fontWeight: "bold", color: "var(--mainColor)" }}>{i18nManager.Labels.common.close}</span>} onClick={() => {
                            dialog.hide();
                        }} />
                        {secondaryComponents}
                    </div>
                    <div>
                        {article?.title && (<Button raised style={{ padding: "10px 35px" }} scheme={Scheme.DANGER} text={labels.delete} onClick={() => props.onDelete(article)} />)}
                        <Button raised style={{ padding: "10px 35px", marginLeft: 20 }} scheme={Schemes.RIVTN_QUIRINUS} text={article?.title ? labels.update : labels.publish} onClick={(e) => {
                            props.onAction(article, e.manageRef, dialogErrorRef);
                        }} />
                    </div>
                </div>
            </FormGroup>
            <iframe ref={iframeRef} src={'data:text/html;charset=utf-8,' + encodeURIComponent(Utils.MARKDOWN_CONVERTER.makeHtml(article?.content ?? ''))} />
        </div>),
    });

    return dialog;
};
